var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWpc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 841.89 118.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #084b72;\n      }\n\n      .st1 {\n        fill: url(#radial-gradient12);\n      }\n\n      .st2 {\n        fill: url(#radial-gradient10);\n      }\n\n      .st3 {\n        fill: url(#radial-gradient13);\n      }\n\n      .st4 {\n        fill: url(#radial-gradient11);\n      }\n\n      .st5 {\n        fill: url(#radial-gradient);\n      }\n\n      .st6 {\n        fill: url(#linear-gradient);\n      }\n\n      .st7 {\n        fill: url(#radial-gradient1);\n      }\n\n      .st8 {\n        fill: url(#radial-gradient6);\n      }\n\n      .st9 {\n        fill: url(#radial-gradient9);\n      }\n\n      .st10 {\n        fill: url(#radial-gradient8);\n      }\n\n      .st11 {\n        fill: url(#radial-gradient3);\n      }\n\n      .st12 {\n        fill: url(#radial-gradient2);\n      }\n\n      .st13 {\n        fill: url(#radial-gradient5);\n      }\n\n      .st14 {\n        fill: url(#radial-gradient4);\n      }\n\n      .st15 {\n        fill: url(#radial-gradient7);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 464.54,
    cy: -770.37,
    fx: 464.54,
    fy: -770.37,
    r: 76.93,
    gradientTransform: "translate(0 -681.75) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c85503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e18d0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd215"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient1",
    cx: 690.34,
    cy: -591.77,
    fx: 690.34,
    fy: -591.77,
    r: 229.09,
    gradientTransform: "translate(0 -681.75) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c85503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e18d0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd215"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient2",
    cx: 690.34,
    cy: -591.77,
    fx: 690.34,
    fy: -591.77,
    r: 229.09,
    gradientTransform: "translate(0 -681.75) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c85503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e18d0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd215"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient3",
    cx: 690.34,
    cy: -591.77,
    fx: 690.34,
    fy: -591.77,
    r: 229.09,
    gradientTransform: "translate(0 -681.75) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c85503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e18d0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd215"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient4",
    cx: 690.34,
    cy: -591.77,
    fx: 690.34,
    fy: -591.77,
    r: 229.09,
    gradientTransform: "translate(0 -681.75) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c85503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e18d0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd215"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient5",
    cx: 690.34,
    cy: -591.77,
    fx: 690.34,
    fy: -591.77,
    r: 229.09,
    gradientTransform: "translate(0 -681.75) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c85503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e18d0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd215"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient6",
    cx: 690.34,
    cy: -591.77,
    fx: 690.34,
    fy: -591.77,
    r: 229.09,
    gradientTransform: "translate(0 -681.75) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c85503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e18d0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd215"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient7",
    cx: 257.14,
    cy: -647.87,
    fx: 257.14,
    fy: -647.87,
    r: 142.71,
    gradientTransform: "translate(0 -681.75) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c85503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e18d0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd215"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient8",
    cx: 257.14,
    cy: -647.87,
    fx: 257.14,
    fy: -647.87,
    r: 142.71,
    gradientTransform: "translate(0 -681.75) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c85503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e18d0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd215"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient9",
    cx: 257.14,
    cy: -647.87,
    fx: 257.14,
    fy: -647.87,
    r: 142.71,
    gradientTransform: "translate(0 -681.75) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c85503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e18d0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd215"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient10",
    cx: 257.14,
    cy: -647.87,
    fx: 257.14,
    fy: -647.87,
    r: 142.71,
    gradientTransform: "translate(0 -681.75) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c85503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e18d0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd215"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient11",
    cx: 257.14,
    cy: -647.87,
    fx: 257.14,
    fy: -647.87,
    r: 142.71,
    gradientTransform: "translate(0 -681.75) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c85503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e18d0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd215"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient12",
    cx: 257.14,
    cy: -647.87,
    fx: 257.14,
    fy: -647.87,
    r: 142.71,
    gradientTransform: "translate(0 -681.75) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c85503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e18d0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd215"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 51.33,
    y1: -619,
    x2: 28.94,
    y2: -820.58,
    gradientTransform: "translate(0 -681.75) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c85503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e18d0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd215"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient13",
    cx: 119.59,
    cy: -626.59,
    fx: 119.59,
    fy: -626.59,
    r: 202.82,
    gradientTransform: "translate(0 -681.75) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c85503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e18d0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd215"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M444.57,98.09c-.35,0-.63-.28-.63-.63V19.37c0-.35.28-.63.63-.63s.63.28.63.63v78.1c0,.35-.28.63-.63.63Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M497.78,47.88h-5.94l-11.22-33.7h6.15l8.26,24.92,8.65-24.92h5.2l8.42,25.05,8.46-25.05h5.8l-11.26,33.7h-5.8l-8.39-24.48-8.33,24.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M539.58,43.29c-3.35-3.17-5.14-7.43-5.14-12.29s1.81-9.06,5.14-12.27c3.28-3.17,7.78-4.89,12.8-4.89s9.43,1.7,12.73,4.84c3.33,3.19,5.09,7.48,5.09,12.32s-1.76,9.2-5.09,12.34c-3.28,3.19-7.7,4.89-12.73,4.89s-9.52-1.76-12.8-4.93h0ZM564.26,30.99c0-6.72-5.09-11.74-11.88-11.74s-12,5-12,11.74,5.09,11.81,12,11.81,11.88-5.02,11.88-11.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M581.9,47.88h-5.94V14.18h14.36c2.94,0,5.48.46,7.52,1.37,4.31,1.93,6.65,5.69,6.65,10.55,0,2.43-.57,4.57-1.72,6.4-1.37,2.09-3.35,3.61-5.89,4.52l7.7,10.85h-6.65l-6.9-9.81h-9.13v9.81h0ZM581.9,19.5v13.22h8.28c5.46,0,8.37-2.3,8.37-6.61s-2.91-6.61-8.37-6.61h-8.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M615.7,47.88h-5.94V14.18h5.94v17.14l16.63-17.14h7.11l-14.48,15.25,15.23,18.44h-7.13l-12.11-14.11-5.26,5.35v8.76h.01Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M665.45,47.88h-5.94V14.18h14.36c2.94,0,5.48.46,7.52,1.37,4.31,1.93,6.65,5.69,6.65,10.55,0,2.43-.57,4.57-1.72,6.4-2.34,3.63-6.68,5.55-12.46,5.55h-8.42v9.83h0ZM665.45,19.5v13.22h8.28c5.46,0,8.37-2.3,8.37-6.61s-2.91-6.61-8.37-6.61h-8.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M720.49,47.88h-26.7V14.18h26.81v5.32h-20.88v8.94h18.9v5.28h-18.9v8.81h20.76v5.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M733.43,47.88h-5.94V14.18h14.36c2.94,0,5.48.46,7.52,1.37,4.31,1.93,6.65,5.69,6.65,10.55,0,2.43-.57,4.57-1.72,6.4-1.37,2.09-3.35,3.61-5.89,4.52l7.7,10.85h-6.65l-6.9-9.81h-9.13v9.81h0ZM733.43,19.5v13.22h8.28c5.46,0,8.37-2.3,8.37-6.61s-2.91-6.61-8.37-6.61h-8.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M767.07,47.88h-5.78V14.18h4.81l13.16,22.14,12.92-22.14h4.81l.09,33.7h-5.76l-.04-21.86-10.69,17.94h-2.87l-10.67-17.81v21.72h.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M809.94,47.88h-5.94V14.18h5.94v33.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M830.79,47.88h-5.89v-28.38h-11.11v-5.32h28.1v5.32h-11.11v28.38h.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M487.05,100.48c-3.14-2.99-4.81-7.01-4.81-11.54s1.67-8.54,4.81-11.54c3.06-2.95,7.22-4.53,11.91-4.53,5.18,0,9.54,1.89,12.37,5.36l-3.67,3.57c-2.21-2.56-5.08-3.85-8.54-3.85-6.52,0-11.31,4.64-11.31,11.01s4.78,11.07,11.31,11.07c3.48,0,6.32-1.29,8.52-3.9l3.69,3.57c-2.86,3.48-7.27,5.39-12.4,5.39-4.73,0-8.89-1.62-11.87-4.6h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M520.45,100.46c-3.14-2.97-4.81-6.97-4.81-11.52s1.7-8.5,4.81-11.51c3.07-2.97,7.29-4.58,12-4.58s8.84,1.6,11.93,4.53c3.11,2.99,4.78,7.01,4.78,11.54s-1.65,8.62-4.78,11.57c-3.07,2.99-7.22,4.58-11.93,4.58s-8.92-1.65-12-4.62h0ZM543.59,88.94c0-6.3-4.78-11.01-11.14-11.01s-11.24,4.69-11.24,11.01,4.78,11.07,11.24,11.07,11.14-4.71,11.14-11.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M560.11,104.75h-5.57v-31.59h4.48l17.29,21.48v-21.48h5.57v31.59h-4.45l-17.31-21.5v21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M588.34,100.78l2.18-4.53c2.25,2.39,6.34,3.93,10.19,3.93,1.72,0,3.05-.19,4.06-.58,1.9-.71,2.81-1.88,2.81-3.46,0-.88-.23-1.53-.79-2.07-1.09-1.04-2.88-1.74-5.96-2.43-5.85-1.32-11.61-2.88-11.61-9.5,0-1.67.45-3.27,1.33-4.67,1.9-3.01,5.72-4.62,10.88-4.62,3.94,0,8,1.16,10.56,3.07l-1.95,4.64c-2.41-1.83-5.46-2.81-8.61-2.81-1.67,0-2.97.21-3.97.63-1.85.74-2.76,1.91-2.76,3.55,0,.95.26,1.6.84,2.11,1.05.99,2.73,1.67,5.92,2.37,5.78,1.42,11.63,2.84,11.63,9.44,0,1.65-.47,3.25-1.35,4.58-1.93,3.04-5.83,4.67-11.03,4.67-4.92,0-9.87-1.7-12.37-4.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M619.55,91.04v-17.87h5.57v17.72c0,6.11,2.62,9.12,7.94,9.12s7.98-2.97,7.98-9.12v-17.72h5.44v17.87c0,8.92-4.88,14.04-13.46,14.04s-13.46-5.14-13.46-14.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M677.96,104.75h-25.03v-31.59h5.57v26.58h19.46v5.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M691.76,104.75h-5.53v-26.6h-10.4v-4.99h26.34v4.99h-10.4v26.6h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M705.98,104.75h-5.85l14.32-31.59h5.08l14.37,31.59h-5.96l-3.64-8.31h-14.69l-3.64,8.31h.01ZM716.94,79.73l-5.27,12.02h10.56l-5.29-12.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M744.3,104.75h-5.57v-31.59h4.48l17.29,21.48v-21.48h5.57v31.59h-4.45l-17.31-21.5v21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M777.34,100.48c-3.14-2.99-4.81-7.01-4.81-11.54s1.67-8.54,4.81-11.54c3.06-2.95,7.22-4.53,11.91-4.53,5.18,0,9.54,1.89,12.37,5.36l-3.67,3.57c-2.21-2.56-5.08-3.85-8.54-3.85-6.52,0-11.31,4.64-11.31,11.01s4.78,11.07,11.31,11.07c3.48,0,6.32-1.29,8.52-3.9l3.69,3.57c-2.86,3.48-7.27,5.39-12.4,5.39-4.73,0-8.89-1.62-11.87-4.6h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M822.92,104.75h-5.53v-11.03l-12.54-20.55h6.06l9.35,15.39,9.44-15.39h5.74l-12.54,20.64v10.94h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277.05,14.41c-7.14-7.14-17.01-11.57-27.91-11.57h-70.75v116.07h17.99v-37.13h52.76c21.79,0,39.47-17.67,39.47-39.47,0-10.9-4.42-20.76-11.55-27.91h-.01ZM263.86,54.14c0,6.78-4.96,12.55-11.65,13.52-18.29,2.67-34.44-10.23-55.83-6.64V28.89c0-6.94,5.21-12.83,12.12-13.59,17.92-1.96,35.14,8.38,55.37,3.46v35.38h-.01Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M232.41,21.23l-1.14,3.52s-.06.08-.1.08h-3.71c-.1,0-.15.13-.07.19l2.99,2.18s.06.08.03.12l-1.14,3.52c-.03.1.08.18.17.12l2.99-2.18s.09-.02.12,0l2.99,2.18c.08.06.19-.02.17-.12l-1.14-3.52s0-.09.03-.12l2.99-2.18c.08-.06.04-.19-.07-.19h-3.71s-.09-.03-.1-.08l-1.14-3.52c-.03-.1-.17-.1-.2,0h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M233.76,53.34l-1.14-3.52c-.03-.1-.17-.1-.2,0l-1.14,3.52s-.06.08-.1.08h-3.71c-.1,0-.15.13-.07.19l2.99,2.18s.06.08.03.12l-1.14,3.52c-.03.1.08.18.17.12l2.99-2.18s.09-.02.12,0l2.99,2.18c.08.06.19-.02.17-.12l-1.14-3.52s0-.09.03-.12l2.99-2.18c.08-.06.04-.19-.07-.19h-3.71s-.09-.03-.1-.08h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M220.29,46.75l-1.14-3.52c-.03-.1-.17-.1-.2,0l-1.14,3.52s-.06.08-.1.08h-3.71c-.1,0-.15.13-.07.19l2.99,2.18s.06.08.03.12l-1.14,3.52c-.03.1.08.18.17.12l2.99-2.18s.09-.02.12,0l2.99,2.18c.08.06.19-.02.17-.12l-1.14-3.52s0-.09.03-.12l2.99-2.18c.08-.06.04-.19-.07-.19h-3.71s-.09-.03-.1-.08h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M246.18,47.29l-1.14-3.52c-.03-.1-.17-.1-.2,0l-1.14,3.52s-.06.08-.1.08h-3.71c-.1,0-.15.13-.07.19l2.99,2.18s.06.08.03.12l-1.14,3.52c-.03.1.08.18.17.12l2.99-2.18s.09-.02.12,0l2.99,2.18c.08.06.19-.02.17-.12l-1.14-3.52s0-.09.03-.12l2.99-2.18c.08-.06.04-.19-.07-.19h-3.71s-.09-.03-.1-.08h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M242.25,38.02l2.99-2.18s.09-.02.12,0l2.99,2.18c.08.06.19-.02.17-.12l-1.14-3.52s0-.09.03-.12l2.99-2.18c.08-.06.04-.19-.07-.19h-3.71s-.09-.03-.1-.08l-1.14-3.52c-.03-.1-.17-.1-.2,0l-1.14,3.52s-.06.08-.1.08h-3.71c-.1,0-.15.13-.07.19l2.99,2.18s.06.08.03.12l-1.14,3.52c-.03.1.08.18.17.12h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M215.63,38.02l2.99-2.18s.09-.02.12,0l2.99,2.18c.08.06.19-.02.17-.12l-1.14-3.52s0-.09.03-.12l2.99-2.18c.08-.06.04-.19-.07-.19h-3.71s-.09-.03-.1-.08l-1.14-3.52c-.03-.1-.17-.1-.2,0l-1.14,3.52s-.06.08-.1.08h-3.71c-.1,0-.15.13-.07.19l2.99,2.18s.06.08.03.12l-1.14,3.52c-.03.1.08.18.17.12h.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.67,2.85l-37.22,111.34h-22.53l-21.47-36.3c4.49-.59,12.45-2.07,17.48-5.43l13.03,21.08L151.37,2.85h18.3,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M63.24,71.23l-11.77,25.24L17.84,2.85H0l38.4,111.34h23.49l17.94-36.91c-8.96-.56-16.58-6.05-16.58-6.05h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M119.89,2.78v34.93c0,5.65-1.42,10.97-3.92,15.66h0c-1.31,2.46-2.91,4.72-4.76,6.78-2.14,2.37-4.61,4.43-7.35,6.11-5.15,3.9-17.74,4.97-17.74,4.97-6.46-42.8,16.25-58.27,16.88-58.75,1.9-1.48,3.9-2.88,5.99-4.15,2.1-1.28,4.22-2.44,6.39-3.45l4.49-2.08h.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.26,70.45c-3.61-.79-6.99-2.17-10.06-4.03-2.85-1.71-5.43-3.83-7.65-6.27-5.39-5.97-8.68-13.84-8.68-22.44V6.95c17.92,9.73,25.64,21.85,28.35,27.24-2.75,8.89-4.11,20.63-1.96,36.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.28,26.36c4.82-10.05,12.82-17.7,12.93-17.79-2.66-2.97-5.77-5.54-9.21-7.59l-1.62-.97-1.62.97c-5.14,3.07-9.52,5.77-12.79,10.77,0,0,9.3,8.09,12.32,14.62h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M297.22,60.77c0-31.54,26.81-57.93,58.57-57.93,15.87,0,30.25,6.65,40.77,17.17l-14.38,13.31c-6.65-7.51-16.31-12.01-26.6-12.01-20.17,0-36.91,18.02-36.91,39.47s16.73,39.7,37.12,39.7c10.3,0,20.17-4.72,27.04-12.45l14.38,13.08c-10.73,10.94-25.11,17.81-41.63,17.81-31.54,0-58.36-26.6-58.36-58.14h0Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWpc);
export default __webpack_public_path__ + "static/media/wpc.bd26e093eb128b98b4519c30a55845e5.svg";
export { ForwardRef as ReactComponent };